import React, {Component} from 'react'
import PropTypes from 'prop-types'

class SelectedCheckbox extends Component {
    _handleChange = () => {
        const {id, onSelected} = this.props
        const isChecked = this._detectChecked()

        if (typeof onSelected === 'function') {
            onSelected(id, !isChecked)
        }
    }

    _detectChecked = () => {
        const {id, arrSelected} = this.props

        return arrSelected !== undefined && arrSelected.includes(id)
    }

    render() {
        const isChecked = this._detectChecked()

        return (
            <input type='checkbox' checked={isChecked} onChange={this._handleChange}/>
        )
    }
}

SelectedCheckbox.propTypes = {
    arrSelected: PropTypes.array,
    onSelected: PropTypes.func,
    approvedStatus: PropTypes.string
}

export default SelectedCheckbox
